import type { BlockLayoutDef } from '@/lib/use-block-layout';

/**
 * BL-219: bestehende Dashboard-Bloecke ein-/ausblendbar + umsortierbar,
 * localStorage-persistiert (siehe use-block-layout.ts). Granularitaet folgt
 * den bereits im JSX vorhandenen visuellen Abschnitten (Divider/eigene
 * Grids) statt einzelner Cards — Hero und Setup-Checklist bleiben fix, das
 * sind Seiten-Chrome, keine optionalen Inhalts-Bloecke. Eigene Datei statt
 * Konstante in dashboard.tsx, weil die Seite bereits eine BL-112-Baseline-
 * Ausnahme ist und nicht ohne Not weiter wachsen soll.
 */
export const DASHBOARD_BLOCKS: BlockLayoutDef[] = [
  { id: 'kpis', label: 'Kennzahlen (Umsatz, DSO, Auslastung)' },
  { id: 'kanzlei', label: 'Kanzlei-Daten (FiBu/LoBu)' },
  { id: 'verlauf-topkunden', label: 'Umsatz-Verlauf & Top-Kunden' },
  { id: 'dso-by-kunde', label: 'Zahlungsverhalten pro Kunde' },
  { id: 'due-projects', label: 'Fällige Abrechnungen' },
];
